import { HTTP_CP_SignUp_Request, HTTP_CP_SignUp_Request_ENUM_SignUpCreationMethod } from '@api-new/authservice';
import { SignUpState } from '@app/sign-up/models/sign-up.state';
import {
  signUpCreationMethodBuyToLetAdapter,
  signUpCreationMethodFirstTimeBuyerAdapter,
  signUpCreationMethodLandlordAdapter,
  signUpCreationMethodMortgageMonitorAdapter,
  signUpCreationMethodMovingHomeAdapter,
  signUpCreationMethodRemortgageNowAdapter,
} from './sign-up-creation-method.adapter';
import { signUpSmartSearchBasicDataAdapter } from './sign-up-smart-search.adapter';

export const signUpStateToHttpRequestAdapter = (data: SignUpState): HTTP_CP_SignUp_Request | undefined => {
  const clientData = data.user.entity;
  const creationMethod = data.flow.entity.creationMethod;
  const companyId = data.branding.entity?.signUpCompanyId;
  const smartSearch = data.smartSearch.entity;
  const property = data.property.entity;
  const mortgage = data.mortgage.entity;
  const referralCode = data.branding.referralCode;

  const smartSearchBasicData = signUpSmartSearchBasicDataAdapter(smartSearch);

  if (clientData == null || creationMethod == null || companyId == null) {
    console.error('Some important sign up information is missing.');
    return undefined;
  }

  switch (creationMethod) {
    case HTTP_CP_SignUp_Request_ENUM_SignUpCreationMethod.SIGN_UP_CREATION_METHOD_MORTGAGE_MONITOR: {
      return signUpCreationMethodMortgageMonitorAdapter(clientData, property, mortgage, companyId, referralCode);
    }

    case HTTP_CP_SignUp_Request_ENUM_SignUpCreationMethod.SIGN_UP_CREATION_METHOD_REMORTGAGE_NOW: {
      return signUpCreationMethodRemortgageNowAdapter(
        clientData,
        property,
        mortgage,
        smartSearch,
        referralCode,
        companyId,
        smartSearchBasicData,
      );
    }

    case HTTP_CP_SignUp_Request_ENUM_SignUpCreationMethod.SIGN_UP_CREATION_METHOD_FIRST_TIME_BUYER: {
      return signUpCreationMethodFirstTimeBuyerAdapter(clientData, smartSearch, referralCode, companyId, smartSearchBasicData);
    }

    case HTTP_CP_SignUp_Request_ENUM_SignUpCreationMethod.SIGN_UP_CREATION_METHOD_MOVING_HOME: {
      return signUpCreationMethodMovingHomeAdapter(
        clientData,
        property,
        mortgage,
        smartSearch,
        referralCode,
        companyId,
        smartSearchBasicData,
      );
    }

    case HTTP_CP_SignUp_Request_ENUM_SignUpCreationMethod.SIGN_UP_CREATION_METHOD_BUY_TO_LET: {
      return signUpCreationMethodBuyToLetAdapter(clientData, smartSearch, referralCode, companyId, smartSearchBasicData);
    }

    case HTTP_CP_SignUp_Request_ENUM_SignUpCreationMethod.SIGN_UP_CREATION_METHOD_LANDLORD: {
      return signUpCreationMethodLandlordAdapter(clientData, referralCode, companyId);
    }

    default: {
      return undefined;
    }
  }
};
